/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Back_To_VisualInputs */



/**
* | output |
* | --- |
* | "Back to visual editor" |
*
* @param {Editor_Back_To_VisualInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_back_to_visual = /** @type {((inputs?: Editor_Back_To_VisualInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Back_To_VisualInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zum visuellen Editor")
	return /** @type {LocalizedString} */ ("Back to visual editor")
});